import { AdminRole, StudentRole, UserRole } from '@/types';

export const STUDENT_ROLES: readonly StudentRole[] = ['driver', 'rider'];
export const ADMIN_ROLES: readonly AdminRole[] = ['admin', 'super_admin'];
export const USER_ROLES: readonly UserRole[] = [...STUDENT_ROLES, ...ADMIN_ROLES];

export const isStudentRole = (role: string): role is StudentRole =>
  STUDENT_ROLES.includes(role as StudentRole);

export const isAdminRole = (role: string): role is AdminRole =>
  ADMIN_ROLES.includes(role as AdminRole);

export const isUserRole = (role: string): role is UserRole =>
  USER_ROLES.includes(role as UserRole);

export const isSuperAdminRole = (role: string): role is 'super_admin' =>
  role === 'super_admin';

export const getDashboardPath = (role: UserRole) => {
  switch (role) {
    case 'driver':
      return '/driver';
    case 'rider':
      return '/rider';
    case 'admin':
      return '/admin';
    case 'super_admin':
      return '/super-admin';
    default:
      return '/';
  }
};
